import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { WEB_COMPONENT_GZ_INFO_BOX } from '../../../../webcomponents.constants';
import { LinkColor, LinkType } from '../../../../ui/gzLinkComponent/types';

export const templateCompanyBetaProgramsTab = document.createElement('template');

templateCompanyBetaProgramsTab.innerHTML = `
  <style>${styles}</style>
  <style>${commonStyles}</style>

  <div class='wrapper'>
      <div id="section-description">
      <${WEB_COMPONENT_GZ_INFO_BOX} class='hidden'></${WEB_COMPONENT_GZ_INFO_BOX}>
        <gz-text id="description-text" fontSize="14">
            <gz-link id="description-link" type="${LinkType.UNDERLINE}" color="${LinkColor.PRIMARY}"></gz-link>
        </gz-text>
      </div>
      <div class="beta-programs-section">
        <div id='beta-programs-title'>
            <gz-title class='beta-title-element' id='beta-title' fontSize="11" fontWeight="600"></gz-title>
            <gz-title class='beta-title-element' id='status-title' fontSize="11" fontWeight="600"></gz-title>
            <gz-title class='beta-title-element' id='kb-title' fontSize='11' fontWeight='600'></gz-title>
        </div>
        <beta-program-section id="beta-programs"></beta-program-section>
      </div>
      <div id='buttons-container'>
        <gz-button id='enroll-button' class='beta-programs-buttons'></gz-button>
        <gz-button id='rollout-button' class='beta-programs-buttons' color='secondary' type='outline'></gz-button>
      </div>
  </div>
`;
